import script from "./ChannelSlider.vue?vue&type=script&setup=true&lang=js"
export * from "./ChannelSlider.vue?vue&type=script&setup=true&lang=js"

import "./ChannelSlider.vue?vue&type=style&index=0&id=30ae952c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30ae952c"]])

export default __exports__